export const KONE_PARTS_URL = 'https://parts.kone.com';
export const FINLAND_PARTS_URL = 'https://parts.kone.com/#/catalog-PSR-KEF-KNE-FI';
export const EUROPE_PARTS_URL = 'https://spares.kone.com/parts'